module.exports = __webpack_public_path__ + "img/5.44d02172.png";